export namespace Global {
    export const FormControlsWithValueStateSelector = '.form__textfield .form-control, .form__textarea .form-control, .form__password .form-control';
}
